"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerHeaderNavigationClassNames: function() {
        return drawerHeaderNavigationClassNames;
    },
    useDrawerHeaderNavigationStyles_unstable: function() {
        return useDrawerHeaderNavigationStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerHeaderNavigationClassNames = {
    root: 'fui-DrawerHeaderNavigation'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1ig4pwh", null, [
    ".r1ig4pwh{margin:calc(var(--spacingVerticalS) * -1) calc(var(--spacingHorizontalL) * -1);}"
]);
const useDrawerHeaderNavigationStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(drawerHeaderNavigationClassNames.root, styles, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerHeaderNavigationStyles.styles.js.map
